import '../../micro/slider/slider.css'
import Slider from '../../micro/slider/slider.js'

const sliderContainers = Array.from(document.getElementsByClassName('wp-block-gallery'))
let sliderContainer
let slider

for (sliderContainer in sliderContainers) {

    let slides = sliderContainers[sliderContainer].getElementsByClassName("blocks-gallery-item")
    let dots = sliderContainers[sliderContainer].getElementsByClassName("blogSlider__dots--dot")
    let controls = sliderContainers[sliderContainer].parentElement.getElementsByClassName("blog-slider__controls")

    slider = new Slider(slides, dots, controls)
}